import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from 'services/language.service';
import { RelationService } from 'services/relation.service';

@Pipe({
	name: 'translate'
})
export class TranslatePipe implements PipeTransform {

	constructor(public readonly languageService: LanguageService) { }

	translate(identifier: string, textVariables?: any): string | undefined {

		textVariables = textVariables ? RelationService.flattenObject(textVariables) : undefined;
		const variable = this.languageService.getVariable(identifier.toLowerCase(), textVariables);

		if (!variable || variable.text == '') return undefined;

		let result = variable.text;
		for (const key of Object.keys(textVariables ?? {})) {
			result = result.replace('${' + key + '}', textVariables[key]);
		}
		
		return result.trim();
	}

	transform(identifier: string, textVariables?: any): string {
		// If no translation value was found, output identifier and variables as text
		return this.translate(identifier, textVariables) ?? (identifier + (textVariables ? ` ${JSON.stringify(textVariables)}` : ''));
	
	}
}
